/* eslint-disable react/prop-types */
import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import Layout from 'wobi-web-common/dist/components/Layout';
import {Breakpoints} from 'wobi-web-common';
import Header from './components/Header';
import MainContainer from './components/MainContainer';
import Routes from './components/Routes';
import SideBar from './steps/SideBar';
import withStepGuardMiddleware from './utils/StepGuardMiddleware';
import {agentDeveloperUtils} from 'wobi-web-common/dist/components/utils/helpers';
import {setOffersFields} from './utils/persistOfferDetails';
// eslint-disable-next-line import/no-extraneous-dependencies
import {createBrowserHistory} from 'history';
import patchBlockFn from 'history-block-async';

setInterval(() => {
  agentDeveloperUtils.replaceWobiWithAgentName(document);
}
, 500);

const App = ({location}) => {
  const [renderSideBar, setRenderSideBar] = React.useState(false);
  const isMobile = useMediaQuery(`(max-width:${Breakpoints.mobile}px)`);

  const changeSideBar = (isOn) => {
    if (isOn !== renderSideBar) {
      setRenderSideBar(isOn);
    }
  };
  React.useEffect(() => {
    // save the agentDeveloperName in the session storage
    const agentDeveloperName = agentDeveloperUtils.agentData.Agent_Developer_Name_c;
    setOffersFields({agentDeveloperName});
  });

  React.useEffect(() => {
    agentDeveloperUtils.replaceWobiWithAgentName(document);
  });

  // eslint-disable-next-line react/prop-types
  const path = (/#!(\/.*)$/.exec(location.hash) || [])[1];
  // eslint-disable-next-line react/prop-types
  const search = (/\?(.*)$/.exec(location.hash) || [])[1];
  // eslint-disable-next-line no-undef
  const history = createBrowserHistory();
  if (path) {
    history.replace(path);
    if (search) {
      location.search = '?' + search;
      location.hash = '';

      location.pathname = path.replace('?' + search, '');
    } else {
      location.pathname = decodeURIComponent(path);
    }
  }
  return (
    <MainContainer>
      <Layout
        sidebar={renderSideBar ?
          <SideBar/> : false}
        header={<Header isMobile={isMobile}/>}>
        <Routes location={location} changeSideBar={changeSideBar}/>
      </Layout>
    </MainContainer>
  );
};

export default withStepGuardMiddleware(App);
